import { ReactNode } from "react";
import { useQuery } from "@tanstack/react-query";
import { getSession } from "@/api/auth";
import { useMaintenanceMode, useIsSupportAdmin } from "@/hooks/useMaintenanceMode";
import Maintenance from "@/pages/Maintenance";

/**
 * Coupe l'accès aux espaces authentifiés (gérant et salarié) lorsque le mode
 * maintenance global est actif. Les administrateurs support passent au travers.
 * Fail-open : tant que l'état n'est pas connu, l'app s'affiche normalement.
 */
export const MaintenanceGate = ({ children }: { children: ReactNode }) => {
  const { isMaintenanceActive, state, endsAt } = useMaintenanceMode();

  const { data: userId } = useQuery({
    queryKey: ["maintenance-session-user"],
    queryFn: async () => {
      const { data } = await getSession();
      return data.session?.user.id ?? null;
    },
    enabled: isMaintenanceActive,
    staleTime: 60_000,
  });

  const isSupportAdmin = useIsSupportAdmin(isMaintenanceActive ? userId : null);

  if (isMaintenanceActive && !isSupportAdmin) {
    return <Maintenance message={state?.message} endsAt={endsAt} />;
  }

  return <>{children}</>;
};
